import { paywallFlowStore } from '@/stores/PaywallFlowStore';

export function getPaywallMetaFromUrl(searchParams: URLSearchParams): string | null {
  return searchParams.get('meta') || null;
}

export function syncPaywallMetaFromUrl(searchParams: URLSearchParams): void {
  const metaFromUrl = getPaywallMetaFromUrl(searchParams);

  if (metaFromUrl) {
    paywallFlowStore.setMeta(metaFromUrl);
  }
}
